/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { FeatureToggle } from "sirius-platform-support-library/shared/feature-toggles/models/feature-toggle.model";
import { FeatureToggleRecord } from "../models/feature-toggle-record.model";

export class FeatureToggleMapper {
  public namespace: string;

  public constructor(namespace: string) {
    this.namespace = namespace;
  }

  public map(record: FeatureToggleRecord): FeatureToggle {
    return {
      namespace: this.namespace,
      code: record.name,
      enabled: record.active,
    };
  }

  public mapAll(records: FeatureToggleRecord[]): FeatureToggle[] {
    return (records ?? []).map((record) => this.map(record));
  }
}
